import calculateLeads from './leadCalc';

// LA/RA electrode-reversal correction for 1-lead and 6-lead recordings.
// See https://litfl.com/ecg-limb-lead-reversal-ecg-library/ (LA/RA reversal).
// Not applied to 12-lead recordings: the UI toggle is disabled for them
// (physician-operated devices are not susceptible to electrode reversal).
//
// When the LA and RA electrodes are swapped on a 6-lead device:
//   Lead I position (LA-RA)  records -(true Lead I)
//   Lead II position (LA-LL) records  true Lead III
// Corrected leads:
//   true Lead I   = -1 * measured Lead I
//   true Lead III = measured Lead II
//   true Lead II  = true Lead I + true Lead III        (Einthoven's law)
//                 = measured Lead II - measured Lead I
// aVR, aVL, aVF are re-derived from corrected I and II via the standard
// Goldberger formulas, delegated to calculateLeads.
const applyInversion = (samples) => {
    if (!samples) return samples;
    // Never touch 12-lead recordings: presence of any precordial (V*) lead is the signal.
    if (Object.keys(samples).some((k) => k.startsWith('V'))) return samples;

    const { I: measuredI, II: measuredII } = samples;
    if (!measuredI) return samples;

    // 1-lead: only Lead I was measured. Just negate it.
    if (!measuredII) {
        return { I: measuredI.map((v) => -v) };
    }

    // 6-lead: correct the two measured limb leads, then re-derive III/aVR/aVL/aVF.
    const n = Math.min(measuredI.length, measuredII.length);
    const trueI = measuredI.slice(0, n).map((v) => -v);
    const trueII = measuredII.slice(0, n).map((v, i) => v - measuredI[i]);
    const trueIII = measuredII.slice(0, n);

    // Recalculate aVR, aVL, aVF from corrected I, II, and III.
    return calculateLeads({ I: trueI, II: trueII }, trueIII);
};

export default applyInversion;
